import React from 'react';
import {
  Routes,
  Route
} from "react-router-dom";
import { hasLoggedIn } from './util/token';
import './base.scss';
import NotFound from './page/NotFound';
import Login from './page/Login';
import Home from './page/Home';
import Note from './page/Note';
import Footer from './component/footer';

export default function App() {
  React.useEffect(() => {
    document.documentElement.lang = 'zh-CN';//I18N.lang;
    if ('ontouchend' in window) {
      document.documentElement.classList.add('touchevents');
    } else {
      document.documentElement.classList.add('notouchevents');
    }
  }, []);
  return (
    <>
      <main className="main-content container-fluid">
        <Routes>
          <Route path="/app/note/:category/:note" element={<Note />} />
          <Route path="/app/note/:note" element={<Note />} />
          <Route path="/app/category/:category" element={<Home />} />
          <Route index path="/app/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <Login />
      </main>
    </>
  );
}